module.exports = __webpack_public_path__ + "static/media/drdiary_checked.171d5554.png";